import { render } from "./UnitTable.vue?vue&type=template&id=cb17f606&scoped=true"
import script from "./UnitTable.vue?vue&type=script&lang=js"
export * from "./UnitTable.vue?vue&type=script&lang=js"

import "./UnitTable.vue?vue&type=style&index=0&id=cb17f606&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb17f606"]])

export default __exports__